import { omit } from 'lodash-es';

import { FILTER_OPERATOR_ENUMS, FILTER_RULE_ENUMS } from '@constants';
import { formatDate, getCleanedUrlParams } from '@utils';
import { URLS } from 'layouts/DrawerLayout/constants';

export const handleAgentsData = (data = []) => {
  if (!data) {
    return [];
  }

  return data?.map((item) => ({
    status: item.status || '-',
    createdAt: item.createdAt ? formatDate(item.createdAt, 'dd/MM/yyyy') : '-',
    updatedAt: item.updatedAt ? formatDate(item.updatedAt, 'dd/MM/yyyy') : '-',
    email: item?.email || '-',
    firstName: item?.firstName || '-',
    lastName: item?.lastName || '-',
    fullName: `${item?.firstName || ''} ${item?.lastName || ''}`,
    role: item?.role || '-',
    id: item.id,
    userName: item.username || '-',
    isActive: item?.isActive,
    emailSignature: item?.emailSignature,
    statusIsActive: item?.isActive ? 'Active' : 'Inactive',
  }));
};

export const getAgentsUrl = (params) => {
  const urlParams = getCleanedUrlParams(params);
  const searchParams = new URLSearchParams(urlParams).toString();

  return `${URLS.agents}?${searchParams}`;
};

export const getAgentsRequestPayload = (payload = {}) => {
  const fields = omit(payload, ['page', 'pageSize', 'query']) || {};
  const multyFilterStringFields = ['role'];

  const getType = ({ field }) => {
    if (multyFilterStringFields.includes(field)) {
      return FILTER_RULE_ENUMS.IsAnyOfRuleType;
    }
    return FILTER_RULE_ENUMS.ComparableRuleType;
  };

  const getValue = ({ field }) => {
    if (multyFilterStringFields.includes(field)) {
      return payload[field]?.split(',');
    }
    return payload[field];
  };

  const value = [
    ...Object.keys(fields).map((field) => ({
      field,
      operator: FILTER_OPERATOR_ENUMS['='],
      type: getType({ field }),
      value: getValue({ field }),
    })),
  ];

  if (value.length) {
    return {
      type: FILTER_RULE_ENUMS.AndRuleType,
      field: null,
      operator: null,
      value,
    };
  }

  return {
    type: FILTER_RULE_ENUMS.EmptyRuleType,
  };
};
